var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighRiskPeopleCs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "lck4malyca",
    d: "M0 0h6.337v6.38H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.966 .833)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c83vffyvub",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lck4malyca"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.168 6.38c1.747 0 3.169-1.432 3.169-3.19C6.337 1.43 4.915 0 3.168 0 1.422 0 0 1.431 0 3.19c0 1.758 1.422 3.19 3.168 3.19",
    fill: "#AEB3B7",
    mask: "url(#c83vffyvub)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.372 8.05c.416.485.819 1.044 1.197 1.63l-3.327 6.304H2.55a1.893 1.893 0 0 1-1.7-1.009 2.036 2.036 0 0 1-.043-1.834c.72-1.51 1.847-3.635 3.095-5.09l.082-.095a8.672 8.672 0 0 1 .526-.548 5.77 5.77 0 0 1 .452-.386l.041-.03a3.732 3.732 0 0 1 .29-.197 3.933 3.933 0 0 0 5.687 0l.083.052.003.002a3.091 3.091 0 0 1 .204.142l.04.031.043.032a5.77 5.77 0 0 1 .573.513 7.8 7.8 0 0 1 .363.39c.028.03.055.062.082.094M5.31 6.794v.001",
    fill: "#AEB3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.977 6.792.004.003A3.932 3.932 0 0 1 8.24 8.008a3.934 3.934 0 0 0 2.738-1.216M8.036 8.008a3.933 3.933 0 0 1-2.742-1.213l.004-.003a3.934 3.934 0 0 0 2.738 1.216M10.982 6.794a4.453 4.453 0 0 1 0 .001zM15.246 15.947l-.966-3.24h1.931l-.965 3.24zm0 1.944a.642.642 0 0 1-.644-.648.642.642 0 1 1 1.287 0 .642.642 0 0 1-.644.648zm.568-8.623a.645.645 0 0 0-.795-.302.645.645 0 0 0-.342.302l-4.721 8.947c-.106.2-.1.443.016.638a.642.642 0 0 0 .552.314h9.443c.226 0 .435-.12.552-.314a.651.651 0 0 0 .016-.638l-4.721-8.947z",
    fill: "#AEB3B7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighRiskPeopleCs);
export default __webpack_public_path__ + "static/media/high-risk-people-cs.85a60d02.svg";
export { ForwardRef as ReactComponent };